import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

export const usePageTracking = () => {
    const location = useLocation();

    useEffect(() => {
        const consent = localStorage.getItem('cookie_consent');

        if (consent === 'accepted' && window.gtag) {
            window.gtag('event', 'page_view', {
                page_path: location.pathname,
            });
        }
    }, [location.pathname]);
};
